import styled from 'styled-components';
import EventIcon from '@mui/icons-material/Event';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import MapsHomeWorkIcon from '@mui/icons-material/MapsHomeWork';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CategoryIcon from '@mui/icons-material/Category';
import BusinessIcon from '@mui/icons-material/Business';
import OurPartners from './OurPartners';
function DetailBox(props) {
  return (
    <Container>
      <div className="banner-container">
        <img src={props.image} alt="" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-xl-8 col-sm-12">

      <h1>{props.title}</h1>
      <p>
        {props.details}
      </p>
      <div className="event-hightlight">
          <h3>{props.highlight} </h3>
        <ul>
          <li>{props.list1}</li>
          <li>{props.list2}</li>
          <li>{props.list3}</li>
          <li>{props.list4}</li>
          <li>{props.list5}</li>
          <li>{props.list6}</li>
        </ul>
      </div>

      <div>
        <h3>How to Participate?</h3>
        <p>Go to the registration form and fill up the detailed information and book your seat.</p>
        <h3>Who Can Participate?</h3>
        <ul>
          <li>Startup Founders</li>
          <li>Investors</li>
          <li>Entrepreneurs</li>
          <li>General Audience</li>

        </ul>
      </div>

          </div>

        <div className="col-xl-4 event-details justify-content-end">
            <h2 className='h1'>Event Details</h2>
              <p><span><EventIcon/></span> Start Date: </p>
              <p><span><EventRepeatIcon/></span> Final Date: </p>
              <p><span><LocationOnIcon/></span> Location: </p>
              <p><span><MapsHomeWorkIcon/></span> Venue: </p>
              <p><span><BusinessIcon/></span> Organizor: </p>
              <p><span><CategoryIcon/></span> Category: </p>
              <p><span><AccountBalanceWalletIcon/></span> Ticket Price: </p>
              <p><span><DinnerDiningIcon/></span> Food And Drinks:  </p>
          </div>
        </div>

</div>
<OurPartners/>
      <div className="event-enquiry">

      <section class="contact_wrapper container-fluid" id="contact">
            <div class="container">
                <div class="row justify-content-end align-items-center">

                  
                    <div class="order-1 order-lg-2 col-lg-5 mb-lg-0 mb-4 px-5 form">
                      <h1>Event Inquiry</h1>
                        <form class="row g-3 event-inquiry">
                            <div class="col-md-12">
                                <label for="fname" class="form-label">Full Name</label>
                                <input type="text" class="form-control" id="fname"  required/>
                            </div>
                          
                            <div class="col-md-12">
                                <label for="inputEmail4" class="form-label">Email</label>
                                <input type="email" class="form-control" id="inputEmail4"  required/>
                            </div>
                           
                            <div class="col-12">
                                <label for="exampleFormControlTextarea1" class="form-label">Your message</label>
                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" required></textarea>
                            </div>
                            <div class="col-12">
                                <button type="submit" class="btn btn-pri">Submit</button>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </section>


      </div>
      
      

    </Container>  
  )
}

export default DetailBox
const Container = styled.div` 
margin-top:80px ;

.banner-container img{
  width:100% ;
  object-fit: cover;
}
.banner-container{
  margin-bottom:50px ;
}
.event-detail-ul{
  border:1px solid gray;
}
h1,h2{
  color:#fa7525 ;
}
.event-details{
  /* margin-top:50px ; */
  height:450px;
  background-color:#F7F7F7 ;
  padding:20px ;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
}
.event-details span{
  color:#fa7525 ;
}


`